const ENV_SOURCE = (typeof import.meta !== 'undefined' && import.meta.env)
  ? import.meta.env
  : (typeof process !== 'undefined' ? process.env : {});

const API_BASE_URL = String(
  ENV_SOURCE?.VITE_API_URL
  ?? ENV_SOURCE?.VITE_API_BASE_URL
  ?? ''
).replace(/\/+$/, '');

const FRONTEND_REPO = 'Nuosis/NBNA';

function uuid() {
  try {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID();
    }
  } catch {}
  return `re-${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

function buildUrl(path) {
  if (!API_BASE_URL) return path;
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE_URL}${normalized}`;
}

function safeString(value, fallback = '') {
  if (typeof value === 'string') return value;
  if (value == null) return fallback;
  try {
    return String(value);
  } catch {
    return fallback;
  }
}

export async function reportFrontendRuntimeError(payload) {
  try {
    const body = {
      external_id: payload.external_id ?? uuid(),
      source: payload.source ?? 'browser',
      title: payload.title ?? 'Frontend runtime error',
      message: payload.message ?? null,
      exception_type: payload.exception_type ?? null,
      stacktrace: payload.stacktrace ?? null,
      route: payload.route ?? (typeof window !== 'undefined' ? window.location.pathname : null),
      url: payload.url ?? (typeof window !== 'undefined' ? window.location.href : null),
      user_agent: payload.user_agent ?? (typeof navigator !== 'undefined' ? navigator.userAgent : null),
      correlation_id: payload.correlation_id ?? uuid(),
      context: {
        github_repo: FRONTEND_REPO,
        ...(payload.context || {}),
      },
    };

    await fetch(buildUrl('/ops/runtime-errors/frontend'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-devin-repo': FRONTEND_REPO,
        'x-correlation-id': body.correlation_id,
      },
      body: JSON.stringify(body),
      keepalive: true,
    });
  } catch (error) {
    console.error('[runtime-errors] failed to report frontend runtime error:', error);
  }
}

export function installGlobalRuntimeErrorHandlers() {
  if (typeof window === 'undefined') return;
  if (window.__nbnaRuntimeErrorHandlersInstalled) return;
  window.__nbnaRuntimeErrorHandlersInstalled = true;

  window.addEventListener('error', (event) => {
    const err = event?.error;
    reportFrontendRuntimeError({
      source: 'window.error',
      title: safeString(err?.name, 'Unhandled browser error'),
      message: safeString(err?.message ?? event?.message, 'Unhandled browser error'),
      exception_type: safeString(err?.name, null),
      stacktrace: safeString(err?.stack, null),
      context: {
        filename: safeString(event?.filename, null),
        lineno: event?.lineno ?? null,
        colno: event?.colno ?? null,
      },
    });
  });

  window.addEventListener('unhandledrejection', (event) => {
    const reason = event?.reason;
    reportFrontendRuntimeError({
      source: 'window.unhandledrejection',
      title: 'Unhandled promise rejection',
      message: safeString(reason?.message ?? reason, 'Unhandled promise rejection'),
      exception_type: safeString(reason?.name, null),
      stacktrace: safeString(reason?.stack, null),
      context: {
        rejection: safeString(reason, null),
      },
    });
  });
}
